import { Card, Image, makeStyles, Text } from "@fluentui/react-components";
import IPageFeature, { IFeature } from "../../../models/page/pageComponents/IPageFeature";

const useStyles = makeStyles({
    fullCardContent: {
        display: "flex",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        '@media (max-width: 768px)': {
            flexDirection: "column",
        },
    },
    cardsSection: {
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        width: "60%",
        '@media (max-width: 768px)': {
            width: "100%",
        },
    },
    cardWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    halfCard: {
        flex: "1 1 calc(50% - 0.5rem)",
        '@media (max-width: 768px)': {
            flex: "1 1 100%",
        },
    },
    fullCard: {
        flex: "1 1 100%",
    },
    card: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        height: "100%",
        padding: "1rem",
    },
    imageWrapper: {
        width: "100%",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "center",
    },
    fullWidthCardImageWrapper: {
        marginBottom: "0",
        marginRight: "1rem"
    },
    textWrapper: {
        width: "100%",
    },
    halfWidthCardTextWrapper: {
        marginTop: "auto"
    },
    image: {
        width: "100%",
        height: "auto",
        
        '@media (max-width: 768px)': {
            width: "80%",
        },
    }
});

const HalfWidthCard = (props: { feature: IFeature }) => {
    const { feature } = props;
    const styles = useStyles();

    return (
        <div className={`${styles.cardWrapper} ${styles.halfCard}`}>
            <Card className={styles.card}>
                <div className={styles.imageWrapper}>
                    <Image
                        src={feature.image.url}
                        alt={feature.image.altText}
                        className={styles.image}
                        />
                </div>
                <div className={`${styles.textWrapper} ${styles.halfWidthCardTextWrapper}`}>
                    <Text as="h3" block size={500}>{feature.title}</Text>
                    <Text block>{feature.description}</Text>
                </div>
            </Card>
        </div>
    );
};

const FullWidthCard = (props: { feature: IFeature }) => {
    const { feature } = props;
    const styles = useStyles();

    return (
        <div className={`${styles.cardWrapper} ${styles.fullCard}`}>
            <Card className={styles.card}>
                <div className={styles.fullCardContent}>
                    <div className={`${styles.imageWrapper} ${styles.fullWidthCardImageWrapper}`}>
                        <Image
                            src={feature.image.url}
                            alt={feature.image.altText}
                            className={styles.image}
                        />
                    </div>
                    <div className={styles.textWrapper}>
                        <Text as="h3" block size={500}>{feature.title}</Text>
                        <Text block>{feature.description}</Text>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default function FeaturesLayout1(props: IPageFeature) {
    const styles = useStyles();

    return (
        <div className={styles.cardsSection}>
            {
                props.features
                    .map((feature, index) => index % 3 === 2
                        ? <FullWidthCard key={index} feature={feature} />
                        : <HalfWidthCard key={index} feature={feature} />
                    )
            }
        </div>
    );
}